{
	"notAuthorized": "No está autorizado a ver ningún informe de esta sección"
}
